/* eslint-disable import/prefer-default-export */
import store from '../containers/App/store';

export function authHeader() {
  // return authorization header with jwt token
  const state = store.getState();
  let auth;
  if (state.authentication.auth) {
    auth = state.authentication.auth.token;
  }
  if (auth) {
    return `Token ${auth}`;
  }
  return '';
}
